import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { selectIsContactLookupFeatureFlagOn } from 'core/userContext';

import { PageHeader } from 'ui/pageHeader';
import { ErrorBanner } from 'ui/banner';
import { colors, smallShadow, spacing } from 'ui/theme';
import { layoutLRPadding } from 'ui/theme/spacing';

import { Avatar } from './Avatar';
import { ContactDetails } from './ContactDetails';
import { RecentEvents } from './RecentEvents';
import { useUserMetadataQueryContext } from '../contexts/UserMetadataQueryContext';
import { useUserKeyParameter } from '../hooks';
import { GridArea } from './constants';

const displayText = {
  breadcrumb: 'Back to contact lookup',
};

const StyledPageHeader = styled(PageHeader)`
  margin: 0;
  padding: ${spacing.plusHalf} ${layoutLRPadding} ${spacing.double} ${layoutLRPadding};
  background-color: ${colors.white};
  ${smallShadow};
`;

const Wrapper = styled.div`
  display: grid;
  align-items: center;
  font-size: initial;
  font-weight: initial;
  letter-spacing: initial;
  line-height: initial;
  grid-template-columns: min-content minmax(0, 1fr) min-content;
  grid-template-rows: min-content min-content;
  grid-template-areas: '. . ${GridArea.recentEventsTitle}' '${GridArea.avatar} ${GridArea.contactDetails} ${GridArea.recentEventsList}';
  margin-top: -${spacing.base};
`;

const Error = styled(ErrorBanner)`
  width: 100%;
`;

export const Header = () => {
  const userId = useUserKeyParameter(true);
  const { isLoading, isError } = useUserMetadataQueryContext();
  const isContactLookupReactified = useSelector(selectIsContactLookupFeatureFlagOn);

  const pageHeaderProps = {
    breadcrumb: { content: displayText.breadcrumb, href: '/users/lookup' },
    isAngularLink: !isContactLookupReactified,
  };

  if (!isLoading && isError) {
    return (
      <StyledPageHeader data-test="user-profile-header-error" {...pageHeaderProps}>
        <Error title="Not found">User does not exist: {userId}</Error>
      </StyledPageHeader>
    );
  }

  return (
    <StyledPageHeader data-test="user-profile-header" {...pageHeaderProps}>
      <Wrapper>
        <Avatar />
        <ContactDetails />
        <RecentEvents />
      </Wrapper>
    </StyledPageHeader>
  );
};
